import { MAX_BUILDING_LEVEL } from 'constants'
import { canManageBuilding } from './accounts'

export function checkIndustrialResource(state, { type, level }) {
    const upgradeCost = state.settings.buildings[type].costs[level]
    const industrialResourceBalance = state.clan.industrial_resource
    return (industrialResourceBalance >= upgradeCost)
}

export function checkUpgradeVisibility(state, { level }) {
    const hasPermission = canManageBuilding(state.account)
    const maxLevelReached = (level === MAX_BUILDING_LEVEL)
    return (hasPermission && !maxLevelReached)
}

export function upgradeAvailability(state, { type, level }) {
    const nextLevelIsValid = ((level + 1) <= state.stronghold.level)
    const hasEnougthIndustrialResource = checkIndustrialResource(state, { type, level })
    const showUpgrade = checkUpgradeVisibility(state, { level })
    return (nextLevelIsValid && hasEnougthIndustrialResource && showUpgrade)
}



// WEBPACK FOOTER //
// ./helpers/buildings.js